import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  padding: ${Spacing.S12};
`

export const TextContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.S4};
`
